import { NavLink, useLocation } from 'react-router-dom'
import {
  hasExternalLocationWritePermission,
  hasMytomraBackofficePermission,
  hasViewCharitiesPermission,
  hasViewUnclaimedBagsPermission
} from '../services/permission.service'
import { keycloak, CHARITY_APP_URL } from '../lib'
import { NavBar } from '@tomra/design-system-react/navbar'
import { NavigationMenu } from '@tomra/design-system-react/navigation-menu'
import { BrandLogo } from '@tomra/design-system-react/brand-logo'
import { Button } from '@tomra/design-system-react/button'
import { AppMenuMountDiv } from './AppMenuMountDiv'

export const Header = () => {
  const location = useLocation()
  function logout() {
    keycloak.logout()
  }

  return (
    <NavBar className="sticky top-0 z-50">
      <div className="flex w-full items-center justify-between">
        <div className="flex items-center gap-8">
          <BrandLogo className="h-8" />
          <span className="text-2xl font-medium">myTOMRA Manager</span>
        </div>
        <div className="flex items-center gap-4">
          <NavigationMenu.Root>
            <NavigationMenu.List>
              {hasMytomraBackofficePermission() && (
                <NavigationMenu.Item>
                  <NavigationMenu.Link asChild active={location.pathname === '/search'}>
                    <NavLink to="/search">Search</NavLink>
                  </NavigationMenu.Link>
                </NavigationMenu.Item>
              )}

              {hasViewCharitiesPermission() && (
                <NavigationMenu.Item>
                  <NavigationMenu.Link asChild>
                    <a href={CHARITY_APP_URL}>Charities</a>
                  </NavigationMenu.Link>
                </NavigationMenu.Item>
              )}

              {hasViewUnclaimedBagsPermission() && (
                <NavigationMenu.Item>
                  <NavigationMenu.Link asChild active={location.pathname === '/bags'}>
                    <NavLink to="/bags">Bags</NavLink>
                  </NavigationMenu.Link>
                </NavigationMenu.Item>
              )}

              {hasExternalLocationWritePermission() && (
                <NavigationMenu.Item>
                  <NavigationMenu.Link asChild active={location.pathname === '/external-locations'}>
                    <NavLink to="/external-locations">External locations</NavLink>
                  </NavigationMenu.Link>
                </NavigationMenu.Item>
              )}
            </NavigationMenu.List>
          </NavigationMenu.Root>
          <div className="bg-black rounded-lg">
            <AppMenuMountDiv />
          </div>
          <Button onClick={logout} variant="outline" className="gap-2">
            <span className="icon-[fluent--sign-out-24-regular] size-4" />
            Logout
          </Button>
        </div>
      </div>
    </NavBar>
  )
}
